import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { wrapConsumer } from '@filters/FilteringContextProvider';
import { filterActions } from '@behavior/filter';
import { inventoriesActions } from '@behavior/inventories';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { Grid } from 'semantic-ui-react';
import {initSelectors} from "@behavior/init";
import {entityType} from "@src/constants";
import useUser from '@behavior/init/getUserV2';

type Props = {
  handleAddNewRecord: () => void;
};

function ViewOptionsContainer({ 
  handleAddNewRecord,
}: Props) {
  const { t } = useTranslation();
  const { user } = useUser();

  return user && initSelectors.isActivityCanCreate(user, entityType.activity) && (
    <Grid.Row className="componentWithBottomMarginNoPadding">
      <Grid.Column style={{ padding: '0px' }}>
        <ButtonWrapper
          label={t('inventory.overview.page.add.new.activity')}
          type="button"
          color="green"
          className="tiny"
          icon="plus"
          onClick={handleAddNewRecord}
        />
      </Grid.Column>
    </Grid.Row>
  );
}

ViewOptionsContainer.propTypes = {
  isRenderExport: PropTypes.bool,
  handleAddNewRecord: PropTypes.func,
};

ViewOptionsContainer.defaultProps = {
  isRenderExport: false,
};

const mapStateToProps = (state: any) => ({
  allFilters: state.filter,
  isReportLoading: state.reports.isReportLoading,
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: {
    applyFilterAction: (entityType: any, filterState: any, filters: any) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
    markAsChecked: (inventoryIds: any) => dispatch(inventoriesActions.markAsChecked(inventoryIds)),
  },
});

export default withRouter(
  wrapConsumer(
    compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(ViewOptionsContainer)
  )
);

